import React from "react";
import { Button, Form, Input, message, Alert, Flex } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import Captcha from "../../components/captcha";
import { openUrlExternally } from '../../utils/jsbridge';

const Regist = () => {
    const [form] = Form.useForm();
    const [imageUrl, setImageUrl] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [actionUrl, setActionUrl] = React.useState();
    const phoneNo = Form.useWatch('phoneNo', form);

    const onSubmit = async () => {
        try {
            const url = new URL(window.location.href);
            const values = await form.validateFields();

            let response = await fetch(`/api/login/reset${url.search}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            let result = await response.json();

            if (result && result.success) {
                // message.success("注册成功！");
                setTimeout(() => {
                    window.location.href = `/login`;
                }, 500);
            } else {
                message.error(result.data);
            }

        } catch (errorInfo) {
            console.log("Failed:", errorInfo);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-[calc(100vh-120px)]">
            <div>
                <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-6 md:p-8">
                    <h2 className="admin-page-title text-center mb-4">重置密码</h2>
                    
                    <Alert 
                        message="新密码将通过短信发送给您，请注意查收。" 
                        type="info" 
                        showIcon 
                        className="mb-6"
                    />
                    
                    <Form form={form} layout="vertical">
                        <Form.Item
                            label="手机号码"
                            name="phoneNo"
                            rules={[
                                { required: true, message: "请输入手机号码" },
                                { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" }
                            ]}
                        >
                            <Input 
                                className="admin-form-input" 
                                placeholder="请输入手机号码" 
                                type="tel"
                                maxLength={11}
                            />
                        </Form.Item>

                        <Form.Item
                            label="短信验证码"
                            name="code"
                            rules={[{ required: true, message: "请输入验证码" }]}
                        >
                            <Captcha 
                                phoneNo={phoneNo} 
                                onSendCode={() => {
                                    console.log("验证码已发送");
                                }}
                            />
                        </Form.Item>
                    </Form>

                    <div className="admin-form-actions mt-6">
                        <Button onClick={() => window.location.href = '/login'}>
                            返回登录
                        </Button>
                        <Button type="primary" onClick={onSubmit}>
                            重置
                        </Button>
                    </div>
                </div>
                
                {/* 底部版权信息 */}
                <p className="px-4 py-3 text-center text-xs text-gray-500 safe-bottom">
                    ©{new Date().getFullYear()}{' '}
                    <a 
                        onClick={() => openUrlExternally('https://www.yxdj.tech/')} 
                        className="hover:text-blue-600 transition-colors active:opacity-70"
                    >
                        杭州优选到家科技有限公司
                    </a>{' '}
                    版权所有<br />
                    浙ICP备2025162413号-3
                </p>
            </div>
        </div>
    );    
};

export default Regist;